module.exports = __webpack_public_path__ + "static/allChips-e528503b8890705f6377338d07735d9e.svg";